import React from 'react'
import styled from 'styled-components'

type NavigationOverlayProps = {
  $isActive?: boolean
}

const NavigationOverlay = styled.div<NavigationOverlayProps>`
  height: 100vh;
  width: 100vw;
  background-color: transparent;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  pointer-events: ${props => (props.$isActive ? 'all' : 'none')};
`

export default NavigationOverlay
